import { Badge } from '@today/ui-primitives'
import { type ReactElement, useId } from 'react'

/** Copy of {@link NotificationsComingSoonView}; each omitted key falls back to English. */
export interface NotificationsComingSoonLabels {
	title: string
	description: string
	badge: string
}

const DEFAULT_LABELS: NotificationsComingSoonLabels = {
	title: 'Notifications',
	description: 'Choose which events notify you and how often you get a digest.',
	badge: 'Coming soon',
}

/** Props for {@link NotificationsComingSoonView}. */
export interface NotificationsComingSoonViewProps {
	labels?: Partial<NotificationsComingSoonLabels>
}

/** The Settings "Notifications" placeholder: a disabled card until per-event preferences ship (organism, TO-197). */
export function NotificationsComingSoonView(props: NotificationsComingSoonViewProps): ReactElement {
	const text = { ...DEFAULT_LABELS, ...props.labels }
	const titleId = useId()
	return (
		<section
			aria-labelledby={titleId}
			aria-disabled="true"
			className="flex flex-col gap-1 rounded-ds-lg border border-ds-border bg-ds-surface-muted p-6"
		>
			<header className="flex flex-wrap items-center gap-3">
				<h2 id={titleId} className="text-ds-lg font-semibold text-ds-text">
					{text.title}
				</h2>
				<Badge>{text.badge}</Badge>
			</header>
			<p className="text-ds-sm text-ds-text">{text.description}</p>
		</section>
	)
}
